import { z } from 'zod';
import { Toggles } from '../permissions.js';
import { Email, Id, Role, ShortText, Timestamp } from './common.js';

export const MemberOutput = z.object({
  membershipId: Id,
  userId: Id,
  name: z.string(),
  email: z.string(),
  role: Role,
  toggles: Toggles,
  createdAt: Timestamp,
  revokedAt: Timestamp.nullable(),
});

export const InvitationOutput = z.object({
  id: Id,
  email: z.string(),
  role: Role,
  toggles: Toggles,
  expiresAt: Timestamp,
  createdAt: Timestamp,
});

/** Annuaire de l'équipe (tous les membres) : nom et rôle, pour l'attribution des dossiers. */
export const TeamDirectoryOutput = z.array(z.object({ membershipId: Id, name: z.string(), role: Role }));

export const TeamOutput = z.object({ members: z.array(MemberOutput), invitations: z.array(InvitationOutput) });

export const InviteInput = z.strictObject({
  email: Email,
  role: Role,
  toggles: Toggles.partial().optional(),
});

export const UpdateMemberInput = z.strictObject({
  role: Role.optional(),
  toggles: Toggles.partial().optional(),
});

export const MemberNameInput = z.strictObject({ name: ShortText });
